import BackgroundImage from "../../../assets/images/ic_frame_mony_yellow.png";
import Grid from "@material-ui/core/Grid";
import React from "react";
import star from "../../../assets/images/img_star.png";
import {connect} from "react-redux";
import {data as reduxData} from "../../../Store/Actions/DataAction";

class SquareAvatar extends React.Component {
    render() {
        const {url,stars,showStars}=this.props.data
        const userStars=this.props.UserData.userData.stats.stars
        return(
            <Grid container alignItems={"center"} justify={"center"}
                  style={{
                      backgroundImage: "url(" + BackgroundImage + ")",
                      backgroundSize: '100% 100%',
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: 'center',
                      position:'relative',
                      overflow:'hidden',
                      borderRadius:'10px',
                      padding:'10px'
                  }}>
                <img src={url} className='setting-avatar-dialog-avatar' alt=""/>
                {
                    (stars!=='0' && stars > userStars)&&
                    <Grid justify={"center"} alignItems={"center"} container style={{
                        width:'100%',height:'100%',backgroundColor:'rgba(0,0,0,0.5)',position:'absolute'}}>
                        <Grid sm={4} xs={4} container alignItems={"center"} justify={"center"}>
                            {stars}
                        </Grid>
                        <Grid sm={3} xs={3} container alignItems={"center"} justify={"center"}>
                            <img src={star} style={{width:'100%',padding:'8px'}} alt=""/>
                        </Grid>
                    </Grid>
                }

            </Grid>
        )
    }

}
const mapStateToProps=state=>({
    UserData:state.UserData,
})
export default connect(mapStateToProps,{reduxData})(SquareAvatar)
